import Filter from "./Filter";
import Accounting from "./Accounting";
import Trips from "./Trips";
import { useEffect, useMemo, useState } from "react";
import { DailyCost, TripReservation } from "../../../types/common.types";
import { useAdmin } from "../../../context/admin";
import AdminService from "../../../services/admin.service";
import styled from "styled-components";
import Traspass from "./Traspass";

export default function Earnings() {
    const {currentDay, endDay, user, setIsListDailyCostsModalOpen} = useAdmin()
    const [trips, setTrips] = useState<TripReservation[]>([])
    const [traspass, setTraspass] = useState<TripReservation[]>([])
    const [dailyCosts, setDailyCosts] = useState<DailyCost[]>([])
    const [type, setType] = useState<string>('all')
    useEffect(() => {
        async function getData() {
            try {
                if (!currentDay) return
                const response = await AdminService.listEarnings(currentDay, endDay)
                setTrips(response.data.trips)
                setTraspass(response.data.traspass)
                setDailyCosts(response.data.daily_costs)
                console.log(response.data)
            } catch (error) {
                console.log(error)
            }
        }
        getData()
    }, [currentDay, endDay])

    const total_operation_costs = useMemo(() => {
        let total = 0
        if (type === 'all' || type === 'trips') {
            trips.forEach (trip => {
                const trip_costs = trip.costs?.map((obj) => obj.value).reduce((a,b) => a +b,0) || 0
                total += trip_costs
            })
        }
        return total
    }, [trips, type])

    const total_income = useMemo(() => {
        let total = 0
        // trips
        if (type === 'all' || type === 'trips') {
            trips.forEach(trip => {
                const agency_pass = trip.reservations.filter(obj => obj.agency.id === user?.user.agency_id)
                const agency_pass_total = agency_pass.map(obj => obj.price).reduce((a,b) => a + b, 0)
                const agency_traspass = trip.reservations.filter(obj => obj.agency.id !== user?.user.agency_id)
                const agency_traspass_total = agency_traspass.map(obj => obj.traspass_price).reduce((a,b) => a + b, 0)
                const commissions = trip.reservations.map(obj => obj.agency.id === user?.user.agency_id ? (obj.sale?.amount ? obj.sale.amount : obj.sale ? (obj.price * obj.passenger.seller?.sell_commission / 100 || 0) : 0)  : 0 ).reduce((a,b) => a + b, 0)
                const earnings = (agency_pass_total - commissions) + agency_traspass_total
                total += earnings
            })
        }
        return total - total_operation_costs
    }, [trips, type, user, total_operation_costs])

    const total_real_income = useMemo(() => {
        let total = 0
        // trips
        if (type === 'all' || type === 'trips') {
            trips.forEach(trip => {
                const commissions = trip.reservations.map(obj => obj.agency.id === user?.user.agency_id ? (obj.sale?.amount ? obj.sale.amount : obj.sale ? (obj.price * obj.passenger.seller?.sell_commission / 100 || 0) : 0)  : 0 ).reduce((a,b) => a + b, 0)
                let total_paid_income = 0 - commissions
                    for (let i = 0; i < trip.reservations.length; i++) {
                        const reservation = trip.reservations[i];
                        if (user?.user.agency_id === reservation.agency.id ) {
                            total_paid_income += reservation.price
                        } else {
                            reservation.payments.forEach(payment => {
                                total_paid_income += payment.amount
                            })
                        }
                    }
                total += total_paid_income
            })
        }
        return total - total_operation_costs
    }, [trips, type, user, total_operation_costs])



    const total_traspass_income = useMemo(() => {
        let total = 0
        if (type === 'all' || type === 'traspass') {
            traspass.forEach(trip => {
                const agency_sale = trip.reservations.map(obj => obj.price).reduce((a,b) => a + b, 0)
                const agency_commission = trip.reservations.map(obj => obj.sale?.amount || obj.sale ? (obj.price * obj.passenger.seller?.sell_commission / 100) : 0 || 0).reduce((a,b) => a + b, 0)
                const traspass_cost = trip.reservations.map(obj => obj.traspass_price).reduce((a,b) => a + b, 0)
                total += agency_sale - agency_commission - traspass_cost
            })
        }
        return total
    }, [traspass, type])
    
    const total_commission = useMemo(() => {
        // traspass
        let agency_commission = 0 
        traspass.forEach(obj => agency_commission +=  obj.reservations.map(obj => obj.sale?.amount || obj.sale ? (obj.price * obj.passenger.seller?.sell_commission / 100) : 0 || 0).reduce((a,b) => a + b, 0))
        // trips
        let commissions = 0 
        trips.forEach(obj => commissions += obj.reservations.map(obj => obj.agency.id === user?.user.agency_id ? (obj.sale?.amount ? obj.sale.amount : obj.sale ? (obj.price * obj.passenger.seller?.sell_commission / 100 || 0) : 0)  : 0 ).reduce((a,b) => a + b, 0))
        let total = 0
        if (type === 'all') total = agency_commission + commissions
        if (type === 'trips') total = commissions
        if (type === 'traspass') total = agency_commission
        return total
    }, [trips, traspass, type, user])

    const total_sales = useMemo(() => {
        let total = 0
        // trips
        if (type === 'all' || type === 'trips') {
            trips.forEach(obj => total += obj.reservations.map(obj => user?.user.agency_id === obj.agency.id ? obj.price : obj.traspass_price).reduce((a,b) => a + b, 0))
        }
        return total
    }, [trips, type, user])

    const total_daily_costs = useMemo(() => {
        let total = 0
        dailyCosts.forEach(obj => total += obj.amount)
        return total
    }, [dailyCosts])

    const total_net_profit = useMemo(() => {
        return total_real_income + total_traspass_income
    }, [total_real_income, total_traspass_income])

    const gross_profit = useMemo(() => {
        return total_net_profit - total_daily_costs
    }, [total_net_profit, total_daily_costs])

    return (
        <Main>
            <Filter
            setType={setType}
            />
            <div className="actions">
                <button
                onClick={() => setIsListDailyCostsModalOpen(true)}
                >
                    Daily costs
                </button>
            </div>
            <Accounting
            total_net_profit={total_net_profit}
            total_sales={total_sales}
            total_daily_costs={total_daily_costs}
            total_income={total_income}
            total_real_income={total_real_income}
            total_operation_costs={total_operation_costs}
            total_commission={total_commission}
            total_gross_profit={gross_profit}
            total_traspass_income={total_traspass_income}
            />
            {
                (type === 'trips' || type === 'all') &&
                <Trips
                list={trips}
                />
            }
            {
                (type === 'traspass' || type === 'all') &&
                traspass.length > 0 &&
                <span>
                    CLIENTES NO OPERADOS (traspasos)
                </span>
            }
            {
                (type === 'traspass' || type === 'all') &&
                <Traspass
                list={traspass}
                />
            }
        </Main>
    )
}

const Main = styled.div`
> span {
    display: block;
    margin: 20px auto;
    width: fit-content;
}
.actions {
    display: flex;
    margin-bottom: 20px;
    button {
        padding: 10px 15px;
        border: none;
        background-color: #007bff;
        color: white;
        border-radius: 5px;
        cursor: pointer;
        font-size: 14px;
        &:hover {
            background-color: #0056b3;
        }
    }
}
`